/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { FraccioService } from '../../../controllers/Fraccio';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGPostFormService } from '../../yasag-post.service';


@Injectable()
export class FraccioDeleteFormService extends YASAGPostFormService<string> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    codi_fraccio: new FormControl({value: undefined, disabled: false}, [Validators.required]),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: FraccioService,
  ) {
    super('FraccioDelete', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false): Observable<string> {
    const result = val => this.service.delete(val);
    return this._submit('string', result, 'null', value, false );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<string> {
    if (submit) {
      this.submit(value);
    }
    return this._listen(value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
